import { createFileRoute } from "@tanstack/react-router";
import { ChatPanel } from "~/components/showcase/concierge/chat-panel";
import { seo } from "~/lib/seo";
import {
  generateStructuredDataGraph,
  getShowcasePageSchemas,
} from "~/lib/structured-data";
import * as m from "~/paraglide/messages.js";

export const Route = createFileRoute("/(showcase)/showcase/concierge")({
  component: ChatPanel,
  head: () => {
    const title = m.meta_showcase_concierge_title();
    const description = m.meta_showcase_concierge_description();
    const seoData = seo({
      // The hospitality booking demo no longer matches what Lindevo sells.
      // Kept working and crawlable, but out of the index until it is ported
      // out to apps/mockup. Also removed from sitemap.xml.
      noindex: true,
      description,
      path: "/showcase/concierge",
      title,
    });
    const structuredData = generateStructuredDataGraph(
      getShowcasePageSchemas({
        description,
        pageName: title,
        path: "/showcase/concierge",
      })
    );
    return {
      links: seoData.links,
      meta: seoData.meta,
      scripts: [{ children: structuredData, type: "application/ld+json" }],
    };
  },
});
